import { useLang } from "@/i18n/LangContext";
import { useSite } from "@/context/SiteContext";
import { Container, SectionHeader, LLink, ArrowLink } from "@/components/common";
import { Reveal } from "@/components/motion/Reveal";

const SPANS = ["col-span-2 row-span-2", "col-span-1", "col-span-1", "col-span-1", "col-span-1 row-span-2", "col-span-2"];

export function GalleryEditorial() {
  const { t, L } = useLang();
  const { gallery } = useSite();
  const items = gallery.slice(0, 6);
  return (
    <section data-testid="home-gallery" className="bg-sand py-20 md:py-32">
      <Container>
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-6 mb-12">
          <SectionHeader eyebrow={t.home.galleryEyebrow} title={t.gallery.title} />
          <LLink to="gallery" data-testid="gallery-see-all"><ArrowLink>{t.home.galleryCta}</ArrowLink></LLink>
        </div>
        <div className="grid grid-cols-2 md:grid-cols-4 auto-rows-[160px] md:auto-rows-[220px] gap-3 md:gap-4">
          {items.map((g, i) => (
            <Reveal key={g.id} delay={i * 0.06} className={`img-zoom ${SPANS[i] || "col-span-1"}`}>
              <LLink to="gallery" className="block h-full">
                <img src={g.url} alt={L(g.alt)} loading="lazy" className="h-full w-full object-cover" />
              </LLink>
            </Reveal>
          ))}
        </div>
      </Container>
    </section>
  );
}
